module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-contact"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "footer-attention"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("欢迎关注")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a', {
    staticClass: "weixin",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.showWechatCode
    }
  }, [_c('i', {
    staticClass: "icon icon-24 icon-wechat-logo mr10 va-mid"
  }), _vm._v("微信公众号\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "js-qq",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.showQQCode
    }
  }, [_c('i', {
    staticClass: "icon icon-24 icon-qq-logo mr10 va-mid"
  }), _vm._v("QQ公众号\n                ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-copyright"
  }, [_c('p', {
    staticClass: "copyright-cont"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/help/aboutus/",
      "target": "_blank"
    }
  }, [_vm._v("关于我们")]), _vm._v(" |\n            "), _c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/help/contact_us/",
      "target": "_blank"
    }
  }, [_vm._v("联系我们")]), _vm._v(" |\n            "), _c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/help/official_news/",
      "target": "_blank"
    }
  }, [_vm._v("公司新闻")]), _vm._v(" |\n            "), _c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/help/join_us/",
      "target": "_blank"
    }
  }, [_vm._v("招贤纳士")]), _vm._v(" |\n            "), _c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/passport/register_rule",
      "target": "_blank"
    }
  }, [_vm._v("使用协议")]), _vm._v(" |\n            "), _c('a', {
    staticClass: "copy_right",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.protocolDialogVisible = true
      }
    }
  }, [_vm._v("版权声明")]), _vm._v(" |\n            "), _c('a', {
    attrs: {
      "href": "http://open.ximalaya.com",
      "target": "_blank"
    }
  }, [_vm._v("开放平台")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright-cont"
  }, [_vm._v("\n            Copyright © 2012-2018 www.ximalaya.com lnc.ALL Rights Reserved\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-cont"
  }, [_vm._v("\n            上海证大喜马拉雅网络科技有限公司 版权所有\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-cont"
  }, [_vm._v("\n            沪网文【2016】6034-453号沪ICP备13027243号-3沪公网安备 31011502005603号\n        ")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "top": "30%",
      "close-on-click-modal": true,
      "show-close": false,
      "size": "tiny"
    },
    model: {
      value: (_vm.wechatDialogVisible),
      callback: function($$v) {
        _vm.wechatDialogVisible = $$v
      },
      expression: "wechatDialogVisible"
    }
  }, [_c('span', {
    slot: "default"
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "code_xmly_weixin.jpg")
    }
  })]), _vm._v(" "), _c('span', {
    slot: "title"
  }), _vm._v(" "), _c('span', {
    slot: "footer"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "top": "30%",
      "close-on-click-modal": true,
      "show-close": false,
      "size": "tiny"
    },
    model: {
      value: (_vm.QQDialogVisible),
      callback: function($$v) {
        _vm.QQDialogVisible = $$v
      },
      expression: "QQDialogVisible"
    }
  }, [_c('span', {
    slot: "default"
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "code_xmly_qq.jpg")
    }
  })]), _vm._v(" "), _c('span', {
    slot: "title"
  }), _vm._v(" "), _c('span', {
    slot: "footer"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "版权声明",
      "custom-class": "protocol-pop",
      "top": "15%",
      "close-on-click-modal": true,
      "show-close": false,
      "size": "small"
    },
    model: {
      value: (_vm.protocolDialogVisible),
      callback: function($$v) {
        _vm.protocolDialogVisible = $$v
      },
      expression: "protocolDialogVisible"
    }
  }, [_c('div', {
    slot: "default"
  }, [_c('p', {
    staticClass: "indented"
  }, [_vm._v("上海证大喜马拉雅网络科技有限公司（以下简称：“喜马拉雅网”）根据用户指令提供作品上传、下载以及传播等，向来十分重视网络版权及其他知识产权以及用户权益的保护。")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("如果您认为喜马拉雅网用户通过喜马拉雅网提供的信息存储空间所上载、传播的视听内容侵犯了您的相关权益的，请您向喜马拉雅网发出权利通知，喜马拉雅网将根据相关法律规定采取措施删除相关内容，您可以向喜马拉雅网所设立的专门接受版权投诉和侵权通知的邮箱发送通知书。")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#fc5832",
      "font-weight": "400"
    }
  }, [_vm._v("肖像、名誉等申诉")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("其中侵犯公民个人名誉权、肖像权的投诉资料请发至： tousu@ximalaya.com")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#fc5832",
      "font-weight": "400"
    }
  }, [_vm._v("版权申诉")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("侵犯个人或单位的著作权、商标权等知识产权的情况请将投诉资料发至：banquan@ximalaya.com")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#fc5832",
      "font-weight": "400"
    }
  }, [_vm._v("申诉需知")]), _vm._v(" "), _c('p', [_vm._v("投诉方应当提供包含下列文件：")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("1、完整填写的申请书")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("2、权利人的姓名（名称）、联系方式、地址、身份证扫描件（自然人）、企业法人营业执照（单位）、法定代表人身份证明（单位）；")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("3、要求删除或者断开链接的侵权作品的准确名称和网络地址，以便喜马拉雅网能够发现并初步审核涉嫌侵权作品；")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("4、认为构成侵权的初步证明材料，包括但不限于对作品享有版权或依法享有信息网络传播权的权属证明，以及对涉嫌侵权作品侵权事实的举证。")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("5、通知书需由权利人或其合法授权人亲笔签名，若为单位则需加盖单位公章。")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("6、权利人应对通知书的真实性负责。若通知书的内容不真实，权利人将承担由此造成的全部法律责任。")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("一旦收到符合上述要求之通知，我们将在合理时间内删除涉嫌侵权的作品。如不符合上述条件，我们会请阁下提供相应信息，且暂不采取包括删除等相应措施。")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("在喜马拉雅网上载作品的用户视为同意喜马拉雅网就前款情况所采用的相应措施。喜马拉雅网不因此而承担任何违约责任或其他任何法律责任。喜马拉雅网在收到上述通知后会发送电子邮件通知上载该等作品的用户。对于多次上载涉嫌侵权作品的用户，我们将取消其用户资格。")]), _vm._v(" "), _c('p', [_vm._v("附件")]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("1、"), _c('a', {
    attrs: {
      "href": "http://s1.xmcdn.com/doc/copyright_personal.doc?20150529090608"
    }
  }, [_vm._v("申请书（个人适用）")])]), _vm._v(" "), _c('p', {
    staticClass: "indented"
  }, [_vm._v("2、"), _c('a', {
    attrs: {
      "href": "http://s1.xmcdn.com/doc/copyright_unit.doc?20150529090608"
    }
  }, [_vm._v("申请书（法人单位适用）")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "http://blog.ximalaya.com/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "icon icon-24 icon-ximalaya-logo mr10 va-mid"
  }), _c('span', [_vm._v("官方博客")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "http://weibo.com/ximala/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "icon icon-24 icon-weibo-logo mr10 va-mid"
  }), _vm._v("新浪微博\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "http://tieba.baidu.com/f?kw=%E5%96%9C%E9%A9%AC%E6%8B%89%E9%9B%85fm",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "icon icon-24 icon-baidu-logo mr10 va-mid"
  }), _vm._v("贴吧\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "http://buluo.qq.com/p/barindex.html?bid=272710",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "icon icon-24 icon-tribe-logo mr10 va-mid"
  }), _vm._v("兴趣部落\n                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5055c3c2!./~/vue-loader/lib/selector.js?type=template&index=0!./views/components/Footer.vue
// module id = 324
// module chunks = 0